import { HttpMethods } from '../enums';
import { QueryKeys, QueryError } from '../queries';

import { useCustomMutation } from '.';

interface FederalProformaRow {
  fileId: string;
}

interface DeleteFederalProformaFiles {
  tobeDeletedRows: FederalProformaRow[];
  taxYear: number;
  period: number;
}

export const useMutationDeleteFederalProformaFiles = () =>
  useCustomMutation<null, QueryError, DeleteFederalProformaFiles>({
    handleData: ({ tobeDeletedRows, taxYear, period }) => ({
      url: `/api/efile/federal-proforma-processes/delete-files`,
      method: HttpMethods.DELETE,
      body: {
        tobeDeletedRows,
        taxYear,
        period,
      },
    }),
    resetKey: QueryKeys.FederalProforma.FerderalFileDelete,
    successMessage: 'Delete federal proforma files successfully',
    errorMessage: 'Delete federal proforma files failed',
  });
